<template>
  <main class="login-screen">
    <div class="login-card panel">
      <div class="login-logo"></div>
      <h3>印度蜜蜂</h3>

      <label class="form-field">
        <span class="field-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="8" r="3.4" />
            <path d="M5 20c1.6-4.2 12.4-4.2 14 0" />
          </svg>
        </span>
        <input
          v-model="form.username"
          autocomplete="username"
          aria-label="用户名"
          placeholder="用户名"
          @keyup.enter="handleLogin"
        />
        <span></span>
      </label>

      <label class="form-field">
        <span class="field-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <rect x="5" y="10" width="14" height="10" rx="2" />
            <path d="M8 10V7a4 4 0 0 1 8 0v3" />
          </svg>
        </span>
        <input
          v-model="form.password"
          :type="showPassword ? 'text' : 'password'"
          autocomplete="current-password"
          aria-label="密码"
          placeholder="密码"
          @keyup.enter="handleLogin"
        />
        <button
          type="button"
          class="password-toggle"
          :aria-label="showPassword ? '隐藏密码' : '显示密码'"
          @click="showPassword = !showPassword"
        >
          <svg v-if="!showPassword" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
          <svg v-else viewBox="0 0 24 24" aria-hidden="true">
            <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12z" />
            <circle cx="12" cy="12" r="3" />
            <path d="M4 4l16 16" />
          </svg>
        </button>
      </label>

      <button class="login-btn" :class="{ loading: loading }" @click="handleLogin">
        登 录
      </button>
    </div>
  </main>
</template>

<script>
export default {
  name: 'LoginPage',
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      showPassword: false,
      loading: false
    }
  },
  methods: {
    async handleLogin() {
      if (this.loading) return
      if (!this.form.username || !this.form.password) {
        this.$message.warning('请输入用户名和密码')
        return
      }
      this.loading = true
      try {
        const res = await this.$http.post('/login', this.form)
        if (res.code === 200) {
          localStorage.setItem('token', res.data.token)
          localStorage.setItem('role', res.data.role)
          this.$message.success('登录成功')
          this.$router.push(res.data.role === 'admin' ? '/admin/users' : '/user/profile')
        }
      } catch (e) {
        /* 错误已由拦截器提示 */
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-screen {
  width: 100vw;
  min-height: 100vh;
  display: grid;
  place-items: center;
  position: relative;
  overflow: hidden;
  padding: 28px;
  background:
    radial-gradient(circle at 16% 84%, rgba(50, 200, 245, 0.12), transparent 32%),
    radial-gradient(circle at 84% 14%, rgba(139, 120, 255, 0.14), transparent 30%),
    linear-gradient(135deg, #101927 0%, #121f31 48%, #0f1724 100%);
}

.login-screen::before {
  content: "";
  position: absolute;
  inset: 7%;
  border: 1px solid rgba(50, 200, 245, 0.08);
  border-radius: 8px;
  background:
    linear-gradient(rgba(50, 200, 245, 0.025) 1px, transparent 1px),
    linear-gradient(90deg, rgba(79, 134, 255, 0.026) 1px, transparent 1px);
  background-size: 34px 34px;
  -webkit-mask-image: radial-gradient(circle at center, black, transparent 78%);
  mask-image: radial-gradient(circle at center, black, transparent 78%);
  pointer-events: none;
}

.login-screen::after {
  content: "INDIAN BEE  /  API ACCESS  /  TOKEN LEDGER";
  position: absolute;
  left: 50%;
  bottom: 34px;
  transform: translateX(-50%);
  color: rgba(154, 170, 193, 0.28);
  font-size: 11px;
  font-weight: 900;
  white-space: nowrap;
  letter-spacing: 0;
}

.login-card {
  width: min(500px, calc(100vw - 44px));
  padding: 50px 48px 42px;
  text-align: center;
  position: relative;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(27, 39, 58, 0.94), rgba(19, 29, 45, 0.92));
  border: 1px solid rgba(151, 171, 207, 0.22);
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.28);
  backdrop-filter: blur(18px);
  border-radius: 8px;
}

.login-card::before {
  content: "";
  position: absolute;
  inset: 0 0 auto 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(50, 200, 245, 0.8), rgba(79, 134, 255, 0.82), transparent);
}

.login-logo {
  width: 72px;
  height: 72px;
  margin: 0 auto 20px;
  border-radius: 22px;
  display: grid;
  place-items: center;
  background:
    radial-gradient(circle at 28% 18%, rgba(255,255,255,.94) 0 3%, transparent 4%),
    radial-gradient(circle at 76% 74%, rgba(37,240,255,.42), transparent 42%),
    radial-gradient(circle at 18% 78%, rgba(118,126,255,.28), transparent 36%),
    linear-gradient(150deg, rgba(255,255,255,.18), transparent 34%),
    linear-gradient(145deg, #10203a 0%, #12678b 48%, #20d6f4 100%);
  border: 1px solid rgba(183, 239, 255, .46);
  box-shadow: 0 26px 52px rgba(35,215,255,.3), 0 0 38px rgba(126,236,255,.18), inset -14px -16px 22px rgba(3,8,18,.52), inset 10px 10px 18px rgba(255,255,255,.16);
  position: relative;
  overflow: hidden;
}

.login-logo::before {
  content: "";
  position: absolute;
  width: 32px;
  height: 32px;
  clip-path: polygon(50% 0%, 88% 22%, 88% 78%, 50% 100%, 12% 78%, 12% 22%);
  background:
    linear-gradient(135deg, rgba(255,255,255,.98), rgba(205,252,255,.8) 30%, rgba(35,215,255,.35) 31%, rgba(94,118,255,.58) 100%);
  box-shadow: 0 10px 22px rgba(0,0,0,.38), 0 0 22px rgba(66,236,255,.58), inset 0 0 0 1px rgba(255,255,255,.76), inset -5px -6px 10px rgba(5,12,25,.28);
  z-index: 2;
}

.login-logo::after {
  content: "";
  position: absolute;
  inset: 8px;
  background: no-repeat center/100% 100% url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 72 72' fill='none'%3E%3Cellipse cx='48' cy='25' rx='8.5' ry='12.5' fill='%23ffffff' opacity='.82' transform='rotate(-16 48 25)'/%3E%3Cellipse cx='58' cy='22' rx='6' ry='9' fill='%23cfeaff' opacity='.55' transform='rotate(-38 58 22)'/%3E%3Cpath d='M25.5 34.5c.6-4.5-1-7-3.5-8.5' stroke='%232e1d08' stroke-width='2' stroke-linecap='round'/%3E%3Cpath d='M30.5 34c1.8-3.4 1-6.4-1-8.4' stroke='%232e1d08' stroke-width='2' stroke-linecap='round'/%3E%3Ccircle cx='22' cy='26' r='1.6' fill='%23ffd447'/%3E%3Ccircle cx='29.5' cy='25.7' r='1.6' fill='%23ffd447'/%3E%3Ccircle cx='22' cy='42' r='8.5' fill='%232e1d08'/%3E%3Ccircle cx='19' cy='39.5' r='2.6' fill='%23ffffff'/%3E%3Cpath d='M16.8 44.2c1.3 1.5 3.2 1.8 4.8.7' stroke='%23ffffff' stroke-width='1.6' stroke-linecap='round'/%3E%3Cellipse cx='41' cy='43' rx='17' ry='10.5' fill='%23ffd447' stroke='%232e1d08' stroke-width='2.2'/%3E%3Cpath d='M31 36.5 32 49.5' stroke='%232e1d08' stroke-width='4' stroke-linecap='round'/%3E%3Cpath d='M40 35.8 41.5 50.2' stroke='%232e1d08' stroke-width='4' stroke-linecap='round'/%3E%3Cpath d='M49 36.8 49.5 49.2' stroke='%232e1d08' stroke-width='4' stroke-linecap='round'/%3E%3Cpath d='M58 41.4h6.4l-2.4-2.4.8 4.8-2.4-2.4z' fill='%232e1d08'/%3E%3Cpath d='M30 51c-1 3-2 4-3.5 4.6M40 51.6c0 3.6 0 5 0 5.6M50 51c1.4 2.6 2.4 3.8 4 4.2' stroke='%232e1d08' stroke-width='1.8' stroke-linecap='round'/%3E%3C/svg%3E");
  filter: drop-shadow(0 0 11px rgba(37,240,255,.56));
  opacity: .98;
  z-index: 1;
}

.login-card h3 {
  margin: 0 0 32px;
  font-size: 30px;
  color: var(--text);
  font-weight: 900;
  letter-spacing: 0.02em;
}

.form-field {
  height: 56px;
  margin-bottom: 18px;
  border-radius: 8px;
  border: 1px solid rgba(151, 171, 207, 0.24);
  background: rgba(255, 255, 255, 0.055);
  display: grid;
  grid-template-columns: 34px 1fr 34px;
  align-items: center;
  gap: 8px;
  padding: 0 18px;
  color: var(--text);
  text-align: left;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035);
}

.form-field:focus-within {
  border-color: rgba(50, 200, 245, 0.46);
  box-shadow: 0 0 0 3px rgba(50, 200, 245, 0.07);
}

.form-field input {
  width: 100%;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--text);
  font: inherit;
  font-size: 17px;
}

.form-field input::placeholder {
  color: #71839b;
}

.field-icon {
  color: #8fa3bd;
  width: 22px;
  height: 22px;
  display: grid;
  place-items: center;
}

.field-icon svg {
  width: 21px;
  height: 21px;
  stroke: currentColor;
  stroke-width: 2;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.password-toggle {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #8fa3bd;
  display: grid;
  place-items: center;
  cursor: pointer;
  padding: 0;
}

.password-toggle:hover {
  color: #eaf3ff;
  background: rgba(255, 255, 255, 0.065);
}

.password-toggle svg {
  width: 21px;
  height: 21px;
  stroke: currentColor;
  stroke-width: 2;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.login-btn {
  width: 100%;
  height: 58px;
  margin-top: 4px;
  font-size: 18px;
  font-weight: 850;
  border: 0;
  border-radius: 8px;
  cursor: pointer;
  background: linear-gradient(135deg, #4f86ff, #32bde8);
  color: #fff;
  box-shadow: 0 10px 28px rgba(50, 150, 245, 0.18);
  transition: box-shadow 0.25s, transform 0.2s;
}

.login-btn:hover {
  box-shadow: 0 14px 36px rgba(50, 150, 245, 0.32);
  transform: translateY(-1px);
}

.login-btn.loading {
  opacity: 0.7;
  cursor: progress;
}

@media (max-width: 760px) {
  .login-card {
    padding: 42px 26px 34px;
  }
  .login-card h3 {
    font-size: 26px;
  }
}
</style>